<template>
  <v-layout row wrap class="mx-0 mt-3 auditoriaDetail">
    <v-flex xs12 class="overflow">
      <v-data-table
        ref="dataTable"
        item-key="campos"
        class="auditoriaDetail dataTable"
        sort-by="check"
        :loading="view.elem.datatable.loading"
        :sort-desc.sync="view.elem.datatable.sortdesc"
        :headers="view.elem.datatable.headers"
        :items="view.elem.datatable.data"
        :search="view.elem.datatable.search"
        :must-sort="true"
        :items-per-page="-1"
        :options.sync="options"
        hide-default-footer>
        <template #item.firstCompare="{ item }">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <span v-if="isHTML(item.firstCompare)" v-html="item.firstCompare"></span>
          <img v-else-if="isBase64Img(item.firstCompare)" :src="item.firstCompare" alt="Img" width="60px" class="img-circle my-1" />
          <ul v-else-if="isAdjuntos(item.firstCompare)">
            <li v-for="elem in item.firstCompare.split(',')" :key="elem.split(':')[0]" class="d-inline-flex">
              {{ elem.split(":")[1] }} <v-icon x-small class="pl-1">{{ elem.split(":")[4] == "true" ? "mdi mdi-eye-off" : "mdi mdi-eye" }}</v-icon>
            </li>
          </ul>
          <ul v-else-if="isAdjuntosImages(item.firstCompare)">
            <v-list>
              <v-list-item v-for="elem in getAdjuntosImages(item.firstCompare)" :key="elem[0]">
                <v-list-item-avatar>
                  <v-img :src="`${baseUrl}/api/imageResources/thumb/${elem[4]}/${elem[0]}/${elem[3]}`"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ `${elem[0]}.${elem[3]}` }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </ul>
          <ul v-else-if="isJson(item.firstCompare)">
            <li v-for="elem in getJson(item.firstCompare)" :key="elem.code">
              <b> {{ elem.code }} - {{ elem.name }}</b>
              <ul v-if="elem.popentry">
                <li>
                  <b>{{ $t("view.operativos.substatus.form.direccion.label") }}:&ensp;</b> {{ elem.direccion ? $t("view.commons.yes") : $t("view.commons.no") }}
                </li>
                <li>
                  <b>{{ $t("view.operativos.substatus.form.provincia.label") }}:&ensp;</b> {{ elem.provincia ? $t("view.commons.yes") : $t("view.commons.no") }}
                </li>
                <li>
                  <b>{{ $t("view.operativos.substatus.form.localidad.label") }}:&ensp;</b> {{ elem.localidad ? $t("view.commons.yes") : $t("view.commons.no") }}
                </li>
                <li>
                  <b>{{ $t("view.operativos.substatus.form.codigopostal.label") }}:&ensp;</b> {{ elem.codigopostal ? $t("view.commons.yes") : $t("view.commons.no") }}
                </li>
                <li>
                  <b>{{ $t("view.operativos.substatus.form.telefono.label") }}:&ensp;</b> {{ elem.telefono ? $t("view.commons.yes") : $t("view.commons.no") }}
                </li>
                <li>
                  <b>{{ $t("view.operativos.substatus.form.email.label") }}:&ensp;</b> {{ elem.email ? $t("view.commons.yes") : $t("view.commons.no") }}
                </li>
                <li>
                  <b>{{ $t("view.operativos.substatus.form.whatsapp.label") }}:&ensp;</b> {{ elem.whatsapp ? $t("view.commons.yes") : $t("view.commons.no") }}
                </li>
                <li>
                  <b>{{ $t("view.operativos.substatus.form.iniciativa.label") }}:&ensp;</b> {{ elem.iniciativa ? elem.iniciativa.map((a) => a.name).join(",&ensp;") : "" }}
                </li>
                <li>
                  <b>{{ $t("view.operativos.substatus.form.popentry.label") }}:&ensp;</b>
                  <ul>
                    <li v-for="elem2 in elem.popentry" :key="elem2.code">
                      <b> {{ elem2.name }} </b> - {{ elem2.name }} : {{ elem2.popexit ? elem2.popexit.join().replaceAll(",", ",&ensp;") : "" }}
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
          <span v-else>{{ mapAuditDetailsByType(item.type, item.firstCompare, item.fieldsName) }}</span>
        </template>
        <template #item.secondCompare="{ item }">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <span v-if="isHTML(item.secondCompare)" v-html="item.secondCompare"></span>
          <img v-else-if="isBase64Img(item.secondCompare)" :src="item.secondCompare" alt="Img" width="60px" class="img-circle my-1" />
          <ul v-else-if="isAdjuntos(item.secondCompare)">
            <li v-for="elem in item.secondCompare.split(',')" :key="elem.split(':')[0]" class="d-inline-flex">
              {{ elem.split(":")[1] }} <v-icon x-small class="pl-1">{{ elem.split(":")[4] == "true" ? "mdi mdi-eye-off" : "mdi mdi-eye" }}</v-icon>
            </li>
          </ul>
          <ul v-else-if="isAdjuntosImages(item.secondCompare)">
            <v-list>
              <v-list-item v-for="elem in getAdjuntosImages(item.secondCompare)" :key="elem[0]">
                <v-list-item-avatar>
                  <v-img :src="`${baseUrl}/api/imageResources/thumb/${elem[4]}/${elem[0]}/${elem[3]}`"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ `${elem[0]}.${elem[3]}` }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </ul>
          <ul v-else-if="isJson(item.secondCompare)">
            <li v-for="elem in getJson(item.secondCompare)" :key="elem.code">
              <b> {{ elem.code }} - {{ elem.name }}</b>
              <ul v-if="elem.popentry">
                <li>
                  <b>{{ $t("view.operativos.substatus.form.direccion.label") }}:&ensp;</b> {{ elem.direccion ? $t("view.commons.yes") : $t("view.commons.no") }}
                </li>
                <li>
                  <b>{{ $t("view.operativos.substatus.form.provincia.label") }}:&ensp;</b> {{ elem.provincia ? $t("view.commons.yes") : $t("view.commons.no") }}
                </li>
                <li>
                  <b>{{ $t("view.operativos.substatus.form.localidad.label") }}:&ensp;</b> {{ elem.localidad ? $t("view.commons.yes") : $t("view.commons.no") }}
                </li>
                <li>
                  <b>{{ $t("view.operativos.substatus.form.codigopostal.label") }}:&ensp;</b> {{ elem.codigopostal ? $t("view.commons.yes") : $t("view.commons.no") }}
                </li>
                <li>
                  <b>{{ $t("view.operativos.substatus.form.telefono.label") }}:&ensp;</b> {{ elem.telefono ? $t("view.commons.yes") : $t("view.commons.no") }}
                </li>
                <li>
                  <b>{{ $t("view.operativos.substatus.form.email.label") }}:&ensp;</b> {{ elem.email ? $t("view.commons.yes") : $t("view.commons.no") }}
                </li>
                <li>
                  <b>{{ $t("view.operativos.substatus.form.whatsapp.label") }}:&ensp;</b> {{ elem.whatsapp ? $t("view.commons.yes") : $t("view.commons.no") }}
                </li>
                <li>
                  <b>{{ $t("view.operativos.substatus.form.iniciativa.label") }}:&ensp;</b> {{ elem.iniciativa ? elem.iniciativa.map((a) => a.name).join(",&ensp;") : "" }}
                </li>
                <li>
                  <b>{{ $t("view.operativos.substatus.form.popentry.label") }}:&ensp;</b>
                  <ul>
                    <li v-for="elem2 in elem.popentry" :key="elem2.code">
                      <b> {{ elem2.name }} </b> - {{ elem2.name }} : {{ elem2.popexit ? elem2.popexit.join().replaceAll(",", ",&ensp;") : "" }}
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
          <span v-else>{{ mapAuditDetailsByType(item.type, item.secondCompare, item.fieldsName) }}</span>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import AuditoriaAPI from "@/services/auditoria";
import { getAccounting } from "@/helpers/form-common";
import { formatDate } from "@/helpers/date-methods";
import tippy from "tippy.js";

export default {
  name: "AuditoriaDetailTable"
  , data() {
    return {
      options: {}
      , baseUrl: globalThis.location.origin
      , revision: []
      , view: {
        elem: {
          datatable: {
            data: []
            , search: ""
            , loading: false
            , sortdesc: true
            , headers: [
              { text: this.$t("view.auditoria.detail.campos.th"), align: "left", sortable: true, class: "campos", value: "fields" }
              , { text: this.$t("view.auditoria.detail.anterior.th"), align: "left", sortable: true, class: "secondCompare", value: "secondCompare" }
              , { text: this.$t("view.auditoria.detail.seleccionada.th"), align: "left", sortable: true, class: "firstCompare", value: "firstCompare" }
            ]
          }
        }
      }
    };
  }
  , watch: {
    options: {
      handler() {
        this.load();
      }
      , deep: true
    }
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    async load() {
      this.view.elem.datatable.data = this.revision;
      this.view.elem.datatable.total = Number(this.revision.length);
      this.view.elem.datatable.loading = false;
    }
    , async loadRevision(clave, tabla, descripcion, revision) {
      this.view.elem.datatable.loading = true;

      const respuesta = await AuditoriaAPI.details({ clave, tabla, descripcion, revision });

      // Omitimos todos los campos que termine en CS ya que son campos usados para detectar cambios
      let details = respuesta.data.results.lista.filter((value) => !value.fields.endsWith("cs"));

      this.revision = details;
      this.view.elem.datatable.search = "";
      this.view.elem.datatable.sortdesc = true;
      this.load();
    }
    , async back() {
      this.view.elem.datatable.data = [];
      this.view.elem.datatable.total = 0;
      this.view.elem.datatable.search = "";
      this.view.elem.datatable.sortdesc = true;
    }
    , mapAuditDetailsByType(type, value, fieldsName) {
      if (type === "java.util.Date") {
        return value == "" ? "" : formatDate(value, "DD/MM/YYYY");
      }
      if (type === "java.math.BigDecimal") {
        return value == "" ? "" : getAccounting().formatMoney(value);
      }
      if (fieldsName.includes("password")) {
        return this.$userPermission.hasPermission("ROLE_ACCESO_AUDITORIA_PASS") ? value : "**********";
      }
      return value;
    }
    , getJson(str) {
      const obj = JSON.parse(str);
      if (obj && obj.length > 0 && typeof obj[0] == "string") {
        let newarr = [];
        obj.forEach((str) => {
          newarr.push(JSON.parse(str));
        });
        return newarr;
      }
      return obj;
    }
    , getAdjuntosImages(str) {
      return str ? str.split(",").map((item) => item.split(":")) : null;
    }
    , isJson(str) {
      if (!str || Number.isNaN(str)) return false;
      if (!str.match(/^\[|^\{(?!\{)/)) return false;
      try {
        JSON.parse(str);
      } catch (e) {
        console.log(e);
        return false;
      }
      return true;
    }
    , isHTML(str) {
      let doc = new DOMParser().parseFromString(str, "text/html");
      return str && !Number.isNaN(str) && (Array.from(doc.body.childNodes).some((node) => node.nodeType === 1) || str.includes("<br/>"));
    }
    , isBase64Img(str) {
      return str && !Number.isNaN(str)
        ? str.includes("data:image/") || str.includes("user_thumbnail.jpg") || str.includes("/jpg") || str.includes("/png") || str.includes("/gif") || str.includes("/jpeg")
        : false;
    }
    , isAdjuntos(str) {
      return str && !Number.isNaN(str) && str.includes("/") && str.includes(":") && str.includes(".");
    }
    , isAdjuntosImages(str) {
      return (
        str &&
        !Number.isNaN(str) &&
        str.includes(":") &&
        !Number.isNaN(str.replaceAll(":", "")) &&
        !str.includes("/") &&
        !str.includes("\\") &&
        !str.includes("{") &&
        !str.includes("[") &&
        !str.includes("[") &&
        /(jpe?g|png|gif|bmp|webp|avif)/i.test(str)
      );
    }
  }
};
</script>

<style>
.auditoriaDetail p {
  margin-bottom: 0px;
}
.auditoriaDetail .overflow {
  overflow-y: auto;
  max-height: 600px;
}
.auditoriaDetail .campos {
  min-width: 100px;
}
.auditoriaDetail .v-list {
  background-color: inherit !important;
}
.auditoriaDetail .v-list-item__title {
  color: #676a6c !important;
  font-size: 14px !important;
  font-weight: 400 !important;
}

@media (max-height: 850px) {
  .auditoriaDetail .overflow {
    max-height: 400px !important;
  }
}
@media (max-height: 650px) {
  .auditoriaDetail .overflow {
    max-height: 300px !important;
  }
}
@media (max-height: 510px) {
  .auditoriaDetail .overflow {
    max-height: auto;
    overflow-y: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/auditoria/AuditoriaDetailTable.vue